import React, { useEffect, useState } from "react";

import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { Spinner } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import { ParticipantTypes, RssDocument } from "@api/graphql";
import { FormStepProps } from "@components/form/MultiStepForm";
import { useParseAndValidateCSV } from "@components/resale_submission/csv/ParseFiles";

import { CsvSubmissionFormData } from "./ResaleCsvSubmission";
import { SubmitAllResales } from "./SubmitAllResales";

interface ReuploadCsvSubmissionProps extends FormStepProps<CsvSubmissionFormData, unknown> {
  sourceFile: RssDocument;
}

export const ReuploadCsvSubmission = ({ multiFormData, sourceFile }: ReuploadCsvSubmissionProps) => {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();

  const { resaleInput, loading, success } = useParseAndValidateCSV(
    multiFormData.csvInput,
    sourceFile.participant_id ?? "",
    sourceFile.participant_types?.filter((type): type is ParticipantTypes => type !== null && type !== undefined),
  );

  useEffect(() => {
    if (!loading) {
      if (!success) {
        setModalShow(true);
      } else if (resaleInput && resaleInput.length > 0) {
        setModalShow(false);
        navigate("/submit-all-resales");
      }
    }
  }, [resaleInput, navigate, loading, success]);

  return (
    <Row>
      <Col>
        <Container fluid>
          {resaleInput === undefined ? (
            <div style={{ marginLeft: "auto", marginRight: "auto", textAlign: "center", marginTop: "3em" }}>
              <Spinner style={{ alignSelf: "center" }} />
            </div>
          ) : (
            <SubmitAllResales
              input={resaleInput}
              batchDocument={sourceFile || undefined}
              curatedDocument={multiFormData.csvInput.file || undefined}
            />
          )}
          <Modal show={modalShow} onHide={() => setModalShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title className="ms-auto pt-1">Error</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <p>An error has occurred, please check the contents of the file and try again.</p>
            </Modal.Body>

            <Modal.Footer style={{ alignContent: "center", justifyContent: "center" }}>
              <Button
                variant="primary"
                onClick={() => {
                  navigate("/resale-csv-upload/upload-csv");
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
          ;
        </Container>
      </Col>
    </Row>
  );
};
